import { TypeProps, TypePropsBanner } from './TypeProps';
import { MyLink } from '@app/shared';
import { useAppDispatch } from '@redux/hooks';
import { setModalVideoWhyChoose } from '@redux/slices/modalWindow';
import { TypeBannerByDispatch } from './const';
import { AdBannerImage } from '@app/widgets/ui/Ad';
import classNames from 'classnames';

import styles from './Slider.module.scss';
import { ErrorBoundaryComponent } from '@app/shared/ui/ErrorBoundary';

export const SliderBanner = ({ list, active }: TypeProps): JSX.Element => {
  const dispatch = useAppDispatch();

  const handlerClick = (code: string) => {
    switch (code) {
      case TypeBannerByDispatch.ModalVideoWhyChoose:
        return dispatch(setModalVideoWhyChoose());
    }
  };

  return (
    <div className={styles.Container}>
      {list?.map((banner, index) => (
        <div
          key={index}
          className={classNames(
            styles.Slide,
            active === index && styles.Active,
            active !== index && active !== null && styles.Hide,
            active === null && index === 0 && styles.Preview,
          )}
        >
          {banner?.href ? (
            <MyLink href={banner?.href || ''} reloaded>
              <BannerImage banner={banner} />
            </MyLink>
          ) : (
            <div onClick={() => handlerClick(banner.code)}>
              <BannerImage banner={banner} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export function BannerImage({ banner }: { banner: TypePropsBanner }) {
  return (
    <ErrorBoundaryComponent>
      <AdBannerImage banner={banner} />
    </ErrorBoundaryComponent>
  );
}
